// PaginateFooter.Style.js - MUI 5 compatible styles

const paginateFooterStyles = {
  paginateFooter: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper
  }),

  pagePrev: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  }),

  pageNext: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }),

  pageNumber: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '1 1 auto'
  }),

  fab: (theme) => ({
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabled,
      color: theme.palette.action.disabled
    }
  }),

  button: (theme) => ({
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    textTransform: 'none',
    '&:disabled': {
      color: theme.palette.text.secondary
    }
  })
};

export default paginateFooterStyles; 